/*
 * Broadcast Theme
 *
 * Use this file to add custom Javascript to Broadcast.  Keeping your custom
 * Javascript in this fill will make it easier to update Broadcast. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 */

(function () {
  // Add custom code below this line
  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
  const loyaltyVendorPopup = document.querySelector('[data-favorite-vendor-popup]');
  const loyaltyVendorPopupClose = document.querySelector('[data-popup-close]');

  // API Utility functions for reusable API calls
  const apiUtils = {
    // Base API URL
    baseUrl: 'https://apps.gloross.com/zlatnaribka',

    /**
     * Get a customer's promo card
     * @param {string} email - Customer email
     * @returns {Promise} - API response promise
     */
    // Function to get cookie value by name
    getCookie: function (name) {
      const value = `; ${document.cookie}`;
      const parts = value.split(`; ${name}=`);
      if (parts.length === 2) return parts.pop().split(';').shift();
      return null;
    },
    getPromoCard: function (email) {
      const encodedEmail = encodeURIComponent(email);
      return fetch(`${this.baseUrl}/GetPromoCard?email=${encodedEmail}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
      })
        .then((response) => response.json())
        .catch((error) => {
          console.error('Error fetching promo card:', error);
          throw error;
        });
    },

    /**
     * Create a promo card for a customer
     * @param {Object} params - Parameters for creating a card
     * @param {string} params.email - Customer email
     * @param {string} params.phone - Customer phone
     * @param {string} params.firstName - Customer first name
     * @param {string} params.lastName - Customer last name
     * @param {string} params.location - Where the card is being created from
     * @param {string} [params.store] - Optional store location for in-store cards
     * @returns {Promise} - API response promise
     */
    createPromoCard: function (params) {
      const {email, phone, firstName, lastName, location, store = ''} = params;
      const encodedEmail = encodeURIComponent(email);
      const fullName = `${firstName} ${lastName}`;

      let url = `${this.baseUrl}/CreatePromoCard?email=${encodedEmail}&phone=${phone}&name=${fullName}&location=${location}`;

      if (store) {
        url += `&store=${store}`;
      }

      return fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
      })
        .then((response) => response.json())
        .catch((error) => {
          console.error('Error creating promo card:', error);
          throw error;
        });
    },

    /**
     * Create a Shopify customer
     * @param {Object} params - Customer parameters
     * @param {string} params.firstName - First name
     * @param {string} params.lastName - Last name
     * @param {string} params.email - Email address
     * @param {string} params.marketingState - Marketing preference ('subscribed'|'not_subscribed')
     * @returns {Promise} - API response promise
     */
    createShopifyCustomer: function (params) {
      const {firstName, lastName, email, marketingState, stateAcceptsViber} = params;
      const encodedEmail = encodeURIComponent(email);

      return fetch(
        `https://apps.gloross.com/ZlatnaRibka/CreateShopifyCustomer?firstName=${firstName}&lastName=${lastName}&email=${encodedEmail}&state=${marketingState}&tag=${stateAcceptsViber}`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
        }
      )
        .then((response) => response.json())
        .catch((error) => {
          console.error('Error creating customer:', error);
          throw error;
        });
    },

    /**
     * Change Beauty CArd Recipient
     * @param {Object} params - Customer parameters
     * @param {string} params.email - Email address
     * @param {string} params.cardNumber - Card number
     * @returns {Promise} - API response promise
     */
    changeBeautyCardRecipient: function (params) {
      const {email, cardNumber} = params;
      const encodedEmail = encodeURIComponent(email);

      return fetch(`https://apps.gloross.com/ZlatnaRibka/ChangeCardNumber?card=${cardNumber}&email=${encodedEmail}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
      })
        .then(async (response) => {
          const text = await response.text();
          return text ? JSON.parse(text) : {result: true};
        })
        .catch((error) => {
          console.error('Error changing recipient:', error);
          throw error;
        });
    },

    /**
     * Get Google Wallet card URL
     * @param {string} barcode - Card barcode
     * @param {string} customerName - Customer's full name
     * @returns {Promise} - API response promise
     */
    getGoogleWalletCardUrl: function (barcode, customerName) {
      return fetch(
        `https://apps.gloross.com/ZlatnaRibka/GetGoogleWalletCardUrl?barcode=${barcode}&customerName=${customerName}`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
        }
      )
        .then((response) => response.json())
        .catch((error) => {
          console.error('Error getting Google Wallet card:', error);
          throw error;
        });
    },

    /**
     * Get Apple Wallet card
     * @param {string} barcode - Card barcode
     * @param {string} customerName - Customer's full name
     * @returns {Promise} - API response promise
     */
    getAppleWalletCard: function (barcode, customerName) {
      return fetch(
        `https://apps.gloross.com/ZlatnaRibka/GetAppleWalletCard?barcode=${barcode}&customerName=${customerName}`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
        }
      )
        .then((response) => response.json())
        .catch((error) => {
          console.error('Error getting Apple Wallet card:', error);
          throw error;
        });
    },

    /**
     * Generate account activation URL
     * @param {string} email - Customer email
     * @returns {Promise} - API response promise
     */
    generateAccountActivationUrl: function (email) {
      const encodedEmail = encodeURIComponent(email);

      return fetch(`https://apps.gloross.com/ZlatnaRibka/GenerateAccountActivationUrl?email=${encodedEmail}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
      })
        .then((response) => response.json())
        .catch((error) => {
          console.error('Error generating activation URL:', error);
          throw error;
        });
    },
  };

  // UI Helpers
  const uiHelpers = {
    showLoading: function () {
      const loadingSpinner = document.querySelector('[data-loading-spinner]');
      if (loadingSpinner) loadingSpinner.classList.add('is-visible');
    },

    hideLoading: function () {
      const loadingSpinner = document.querySelector('[data-loading-spinner]');
      if (loadingSpinner) loadingSpinner.classList.remove('is-visible');
    },

    showPopupOverlay: function () {
      const overlay = document.querySelector('[data-popup-overlay]');
      if (overlay) overlay.classList.add('is-visible');
    },

    hidePopupOverlay: function () {
      const overlay = document.querySelector('[data-popup-overlay]');
      if (overlay) overlay.classList.remove('is-visible');
    },

    closePopup: function () {
      beautyCardPopup?.classList.remove('is-visible');
      vendorPopup?.classList.remove('is-visible');
      popupOverlay?.classList.remove('is-visible');
      loyaltyVendorPopup?.classList.remove('is-visible');
    },

    downloadAppleWalletFile: function (fileData, fileName, contentType) {
      // Create a Blob from the data
      const byteCharacters = atob(fileData);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], {type: contentType});

      // Create a URL for the Blob
      const url = URL.createObjectURL(blob);

      // Create an anchor element and trigger the download
      const a = document.createElement('a');
      a.href = url;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();

      // Clean up
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    },
  };

  const customerSettings = JSON.parse(document.querySelector('[data-customer-settings]').textContent);

  const createCustomerForm = document.querySelector('#create_customer');
  const registerLoadingSpinner = document.querySelector('[data-loading-spinner]');

  if (createCustomerForm) {
    // Create Customer Request
    createCustomerForm.addEventListener('submit', (e) => {
      e.preventDefault();
      e.stopImmediatePropagation();
      createCustomerForm.querySelector('button[type="submit"]').disabled = true;

      registerLoadingSpinner.classList.add('is-visible');

      // Extract the value of customer[note][Beauty Card]
      const formData = new FormData(createCustomerForm);
      const beautyCardValue = formData.get('customer[note][Beauty Card]');
      const formFirstName = formData.get('customer[first_name]');
      const formLastName = formData.get('customer[last_name]');
      const formEmail = formData.get('customer[email]');
      const formPhone = formData.get('customer[phone]');

      if (beautyCardValue === 'on') {
        // Use our utility function
        apiUtils
          .createPromoCard({
            email: formEmail,
            phone: formPhone,
            firstName: formFirstName,
            lastName: formLastName,
            location: 'register',
          })
          .then((data) => {
            document.cookie = 'has_beauty_card=true; path=/; max-age=31536000'; // 1 year
            registerLoadingSpinner.classList.remove('is-visible');
          })
          .catch((error) => {
            console.error('Error:', error);
          });

        createCustomerForm.submit();
      } else {
        createCustomerForm.submit();
      }
    });
  }

  const getBeautyCardButton = document.querySelector('[data-get-beauty-card]');
  const createBeautyCardForm = document.querySelector('[data-create-beauty-card]');

  const beautyCardPopup = document.querySelector('[data-beauty-card-popup]');
  const beautyCardPopupCloseBtn = document.querySelector('[data-beauty-card-close]');
  const beautyCardImage = document.querySelector('[data-beauty-card-image]');
  const beautyCardDownloadImage = document.querySelector('[data-beauty-card-download]');
  const beautyCardAppleWallet = document.querySelector('[data-beauty-card-apple-wallet]');
  const beautyCardGoogleWallet = document.querySelector('[data-beauty-card-google-wallet]');
  const beautyCardNumber = document.querySelector('[data-beauty-card-number]');
  const beautyCardPoints = document.querySelector('[data-beauty-card-points]');
  const loadingSpinner = document.querySelector('[data-loading-spinner]');

  const beautyCardSuccess = document.querySelector('[data-beauty-card-success]');
  const beautyCardFail = document.querySelector('[data-beauty-card-fail]');

  const popupOverlay = document.querySelector('[data-popup-overlay]');

  if (getBeautyCardButton) {
    let beautyCardBarcode;

    // GetPromoCard Request

    popupOverlay.addEventListener('click', uiHelpers.closePopup);
    beautyCardPopupCloseBtn.addEventListener('click', uiHelpers.closePopup);

    const customerFirstNameData = getBeautyCardButton.dataset.customerFirstName || 'Име';
    const customerLastNameData = getBeautyCardButton.dataset.customerLastName || 'Фамилия';

    getBeautyCardButton.addEventListener('click', (e) => {
      e.preventDefault();

      uiHelpers.showLoading();

      // Use our utility function
      apiUtils
        .getPromoCard(customerSettings.customerEmail)
        .then((data) => {
          uiHelpers.hideLoading();
          uiHelpers.showPopupOverlay();
          beautyCardPopup.classList.add('is-visible');

          if (data.result == false) {
            beautyCardSuccess.classList.remove('is-visible');
            beautyCardFail.classList.add('is-visible');

            createBeautyCardForm.addEventListener('submit', (e) => {
              e.preventDefault();

              createBeautyCardForm.querySelector('button[type="submit"]').disabled = true;
              uiHelpers.showLoading();

              const formData = new FormData(createBeautyCardForm);
              const customerPhone = formData.get('phone');
              const customerFirstName = formData.get('first_name');
              const customerLastName = formData.get('last_name');

              // Use our utility function
              apiUtils
                .createPromoCard({
                  email: customerSettings.customerEmail,
                  phone: customerPhone,
                  firstName: customerFirstName,
                  lastName: customerLastName,
                  location: 'accountPage',
                })
                .then((data) => {
                  console.log('Success:', data);
                })
                .then(() => {
                  // Fetch the promo card again
                  apiUtils
                    .getPromoCard(customerSettings.customerEmail)
                    .then((data) => {
                      console.log('Success:', data);
                      beautyCardBarcode = data.cardNumber;

                      uiHelpers.hideLoading();
                      beautyCardSuccess.classList.add('is-visible');
                      beautyCardFail.classList.remove('is-visible');

                      beautyCardImage.setAttribute('src', `data:image/png;base64,${data.imageBase64}`);
                      beautyCardDownloadImage.setAttribute('href', `data:image/png;base64,${data.imageBase64}`);
                      beautyCardNumber.textContent = data.cardNumber;
                      beautyCardPoints.textContent = data.points;
                    })
                    .catch((error) => {
                      console.error('Error:', error);
                    });
                })
                .catch((error) => {
                  console.error('Error:', error);
                });
            });
          } else {
            beautyCardBarcode = data.cardNumber; // Assign barcode here
            beautyCardSuccess.classList.add('is-visible');
            beautyCardFail.classList.remove('is-visible');

            beautyCardImage.setAttribute('src', `data:image/png;base64,${data.imageBase64}`);
            beautyCardDownloadImage.setAttribute('href', `data:image/png;base64,${data.imageBase64}`);
            beautyCardNumber.textContent = data.cardNumber;
            beautyCardPoints.textContent =
              data.points + ` (${window.formatMoney(data.points / 0.2, theme.moneyWithCurrencyFormat)})`;
          }
        })
        .catch((error) => {
          console.error('Error:', error);
          uiHelpers.hideLoading();
        });
    });

    beautyCardGoogleWallet?.addEventListener('click', (e) => {
      e.preventDefault();

      if (beautyCardBarcode) {
        // Use our utility function
        apiUtils
          .getGoogleWalletCardUrl(beautyCardBarcode, `${customerFirstNameData} ${customerLastNameData}`)
          .then((data) => {
            if (data.redirectUrl) {
              window.open(data.redirectUrl, '_blank');
            } else {
              console.log('Success:', data);
            }
          });
      } else {
        console.error('beautyCardBarcode is not defined');
      }
    });

    beautyCardAppleWallet?.addEventListener('click', (e) => {
      e.preventDefault();

      if (beautyCardBarcode) {
        // Use our utility function
        apiUtils
          .getAppleWalletCard(beautyCardBarcode, `${customerFirstNameData} ${customerLastNameData}`)
          .then((data) => {
            if (data.success) {
              uiHelpers.downloadAppleWalletFile(data.data, data.fileName, data.contentType);
            } else {
              console.error('Failed to download file');
            }
          });
      } else {
        console.error('beautyCardBarcode is not defined');
      }
    });
  }

  // LOGOS SECTION
  const logosSection = document.querySelector('[data-logos-show-more]');

  if (logosSection) {
    document.addEventListener('DOMContentLoaded', function () {
      // Select the grid element and its children
      const gridElement = document.getElementById('logosGrid');
      const gridItems = Array.from(gridElement.children);

      const mediaQuery = '(max-width: 749px)';
      const mediaQueryList = window.matchMedia(mediaQuery);

      // Calculate the height of the first grid item
      let itemHeight = gridItems[0].offsetHeight;
      let twoRowsHeight = itemHeight * 2;

      const updateHeights = () => {
        itemHeight = gridItems[0].offsetHeight;
        if (mediaQueryList.matches) {
          twoRowsHeight = itemHeight * 7;
        } else {
          twoRowsHeight = itemHeight * 2;
        }

        // Update the max-height of the grid element
        gridElement.style.maxHeight = `${twoRowsHeight}px`;
      };

      // Initial calculation
      updateHeights();

      mediaQueryList.addEventListener('change', (event) => {
        updateHeights();
      });

      // Set the initial max-height to show only the first two rows
      gridElement.style.maxHeight = `${twoRowsHeight}px`;

      // Add event listener to the "Show more" button
      const showMoreButton = document.getElementById('showMoreButton');
      const showLessButton = document.getElementById('showLessButton');

      showMoreButton.addEventListener('click', function () {
        logosSection.classList.add('is-expanded');
        // Calculate the full height of the grid
        const fullHeight = gridElement.scrollHeight;
        gridElement.style.maxHeight = `${fullHeight}px`;
      });

      // Add event listener to the "Show less" button
      showLessButton.addEventListener('click', function () {
        logosSection.classList.remove('is-expanded');
        gridElement.style.maxHeight = `${twoRowsHeight}px`;
      });
    });
  }

  // MARKI NAVIGATION
  const sliderowActionsList = document.querySelectorAll('[data-sliderow-actions]');
  const desktopMenuActionsList = document.querySelectorAll('[data-menu-actions]');

  if (sliderowActionsList.length) {
    sliderowActionsList.forEach((sliderowActions) => {
      const slideRowButtons = Array.from(sliderowActions.children);
  
      slideRowButtons.forEach((button) => {
        button.addEventListener('click', (e) => {
          e.preventDefault();
          const target = e.target;
  
          const dataAttributes = target.dataset;
          const attributeName = Object.keys(dataAttributes)[0];
          const kebabCaseAttributeName = attributeName.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
  
          slideRowButtons.forEach((btn) => {
            btn.classList.remove('is-selected');
          });
          target.classList.add('is-selected');
  
          const allLinks = sliderowActions.parentElement.querySelectorAll('.sliderow__links');
          allLinks.forEach((link) => {
            link.classList.add('hidden');
          });
  
          const brandsToShow = sliderowActions.parentElement.querySelector(`.sliderow__links[data-${kebabCaseAttributeName}]`);
          if (brandsToShow) {
            brandsToShow.classList.remove('hidden');
          }
        });
      });
    });
  }

  if (desktopMenuActionsList.length) {
    desktopMenuActionsList.forEach((desktopMenuActions) => {
      const slideRowButtons = Array.from(desktopMenuActions.children);
  
      slideRowButtons.forEach((button) => {
        button.addEventListener('click', (e) => {
          e.preventDefault();
          const target = e.target;
  
          const dataAttributes = target.dataset;
          const attributeName = Object.keys(dataAttributes)[0];
          const kebabCaseAttributeName = attributeName.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
  
          slideRowButtons.forEach((btn) => {
            btn.classList.remove('is-selected');
          });
          target.classList.add('is-selected');
  
          const allLinks = desktopMenuActions.parentElement.querySelectorAll('[data-brands]');
          allLinks.forEach((link) => {
            link.classList.add('hidden');
          });
  
          const brandsToShow = desktopMenuActions.parentElement.querySelector(`[data-brands][data-${kebabCaseAttributeName}]`);
          if (brandsToShow) {
            brandsToShow.classList.remove('hidden');
          }
        });
      });
    });
  }

  // Issue beauty card
  const issueBeautyCardForm = document.querySelector('#issue-beauty-card');

  issueBeautyCardForm?.addEventListener('submit', (e) => {
    e.preventDefault();

    issueBeautyCardForm.querySelector('button[type="submit"]').disabled = true;
    uiHelpers.showLoading();

    const formData = new FormData(issueBeautyCardForm);
    const customerEmail = formData.get('email');
    const customerFirstName = formData.get('first_name');
    const customerLastName = formData.get('last_name');
    const customerPhone = formData.get('phone');
    const cardIssuer = formData.get('issuer');
    const acceptsMarketing = formData.get('accepts_marketing');
    const acceptsViber = formData.get('accepts_viber');

    const state = acceptsMarketing === 'on' ? 'subscribed' : 'not_subscribed';
    const stateAcceptsViber = acceptsViber === 'on' ? 'viber' : '';

    // Use our utility function
    apiUtils
      .createShopifyCustomer({
        firstName: customerFirstName,
        lastName: customerLastName,
        email: customerEmail,
        marketingState: state,
        stateAcceptsViber: stateAcceptsViber,
      })
      .then((data) => {
        console.log('Success:', data);

        if (data.result) {
          // Use our utility function
          apiUtils
            .createPromoCard({
              email: customerEmail,
              phone: customerPhone,
              firstName: customerFirstName,
              lastName: customerLastName,
              location: 'stores',
              store: cardIssuer,
            })
            .then((data) => {
              uiHelpers.hideLoading();
              console.log(data);

              if (data.result && data.data) {
                document.querySelector('[data-issue-success]').classList.remove('hidden');
              }
            })
            .catch((error) => {
              console.error('Error:', error);
              uiHelpers.hideLoading();
            });
        }
      })
      .catch((error) => {
        console.error('Error:', error);
        uiHelpers.hideLoading();
      });
  });

  // ChangE Beauty Card Recipient

  const changeBeautyCardForm = document.querySelector('#change-beauty-card');

  changeBeautyCardForm?.addEventListener('submit', (e) => {
    e.preventDefault();
    changeBeautyCardForm.querySelector('button[type="submit"]').disabled = true;
    uiHelpers.showLoading();
    const formData = new FormData(changeBeautyCardForm);
    const customerEmail = formData.get('email');
    const cardNumber = formData.get('card_number');

    // Use our utility function
    apiUtils
      .changeBeautyCardRecipient({
        email: customerEmail,
        cardNumber: cardNumber,
      })
      .then((data) => {
        console.log('Success:', data);
        if (data.result) {
          document.querySelector('[data-issue-success]').classList.remove('hidden');

          // Reset the form fields
          changeBeautyCardForm.reset();

          // Re-enable the submit button
          changeBeautyCardForm.querySelector('button[type="submit"]').disabled = false;
        }
        uiHelpers.hideLoading();
      })
      .catch((error) => {
        console.error('Error:', error);

        // Re-enable button on error too
        changeBeautyCardForm.querySelector('button[type="submit"]').disabled = false;

        uiHelpers.hideLoading();
      });
  });

  // ACTIVATE CUSTOMER PROFILES
  const activateAccountForm = document.querySelector('[data-activate-account-form]');

  if (activateAccountForm) {
    activateAccountForm.addEventListener('submit', (e) => {
      e.preventDefault();

      const formData = new FormData(activateAccountForm);
      const customerEmail = formData.get('customer_email');
      uiHelpers.showLoading();

      // Use our utility function
      apiUtils
        .generateAccountActivationUrl(customerEmail)
        .then((data) => {
          console.log('Success:', data);

          if (data.data) {
            window.location.href = data.data;
          }
        })
        .catch((error) => {
          console.error('Error:', error);
          uiHelpers.hideLoading();
        });
    });
  }

  // Debounce helper
  function debounce(fn, wait = 200) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn(...args), wait);
    };
  }

  document.addEventListener('DOMContentLoaded', () => {
    const dropdowns = Array.from(document.querySelectorAll('.header__dropdown'));
    if (!dropdowns.length) return;

    const checkEdges = () => {
      const vw = document.documentElement.clientWidth;
      const buffer = 8; // optional extra breathing room in px

      dropdowns.forEach((dd) => {
        // get distance from viewport left
        const {left} = dd.getBoundingClientRect();
        // total width of the dropdown’s content (including overflow)
        const fullWidth = dd.scrollWidth;
        // if left + fullWidth > viewport width, it’s overflowing
        const overflows = left + fullWidth + buffer > vw;

        dd.classList.toggle('right-edge', overflows);
      });
    };

    // initial check
    checkEdges();
    // on resize
    window.addEventListener('resize', debounce(checkEdges, 150));
  });

  // Copy discount code to clipboard
  const discountCodeCopyButton = document.querySelector('[data-copy-clipboard]');

  if (discountCodeCopyButton) {
    discountCodeCopyButton.addEventListener('click', (e) => {
      e.preventDefault();

      const discountCode = e.target.dataset.discountCode;

      navigator.clipboard.writeText(discountCode).then(
        function () {
          discountCodeCopyButton.querySelector(
            '[data-discount-button-icon]'
          ).style.backgroundImage = `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' aria-hidden='true' focusable='false' role='presentation' fill='transparent' viewBox='0 0 24 24'%3E%3Cpath d='m5 13 4 4L19 7' stroke='%23000' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E")`;
          console.log('Async: Copying to clipboard was successful!');
        },
        function (err) {
          console.error('Async: Could not copy text: ', err);
        }
      );
    });
  }

  /**
   * Subcollections expand/collapse functionality with smooth animation
   * that accounts for responsive column changes
   */
  function initSubcollectionsExpandCollapse() {
    const container = document.querySelector('[data-subcollections-show-more]');
    if (!container) return;

    const showMoreButton = document.getElementById('showMoreButtonSubcollections');
    const showLessButton = document.getElementById('showLessButtonSubcollections');
    const subcollectionItems = container.querySelectorAll('.subcollection__item');

    if (subcollectionItems.length <= 0 || !showMoreButton || !showLessButton) return;

    // Function to get current number of columns based on actual computed style
    function getCurrentColumnsCount() {
      const gridContainer = container.querySelector('.grid');

      if (!gridContainer) return 4; // Default fallback

      // Get the computed style value to account for all active media queries
      const columnsVar =
        getComputedStyle(gridContainer).getPropertyValue('--columns') ||
        getComputedStyle(gridContainer).getPropertyValue('--COLUMNS');

      // Parse the columns value, falling back to 4 if not found
      return parseInt(columnsVar * 2, 10) || 4;
    }
    // Initial setup
    function setupInitialState() {
      const currentColumns = getCurrentColumnsCount();

      subcollectionItems.forEach((item, index) => {
        if (index >= currentColumns) {
          item.style.display = 'none';
          item.dataset.expanded = 'false';
          // Set initial height for animation
          item.style.overflow = 'hidden';
          item.style.maxHeight = '0px';
          item.style.opacity = '0';
          item.style.transform = 'translateY(20px)';
        } else {
          item.dataset.expanded = 'true';
          item.style.display = '';
          item.style.maxHeight = '';
          item.style.opacity = '1';
          item.style.transform = 'translateY(0)';
        }
      });

      showLessButton.style.display = 'none';

      if (subcollectionItems.length <= currentColumns) {
        showMoreButton.style.display = 'none';
      } else {
        showMoreButton.style.display = 'block';
      }
    }

    // Expand all subcollection items with animation
    function expandAll() {
      subcollectionItems.forEach((item) => {
        item.style.display = 'block';
        item.dataset.expanded = 'true';

        // Start the animation
        setTimeout(() => {
          item.style.transition = 'opacity 0.5s ease, transform 0.5s ease, max-height 0.5s ease';
          item.style.maxHeight = '1000px'; // Large enough value to accommodate any height
          item.style.opacity = '1';
          item.style.transform = 'translateY(0)';
        }, 10); // Small delay to ensure display property is applied first
      });

      showMoreButton.style.display = 'none';
      showLessButton.style.display = 'block';
    }

    // Collapse to show only the first row with animation
    function collapseToFirstRow() {
      const currentColumns = getCurrentColumnsCount();
      const itemsToHide = Array.from(subcollectionItems).filter((_, index) => index >= currentColumns);

      // First, animate the items out
      itemsToHide.forEach((item) => {
        item.style.transition = 'opacity 0.4s ease, transform 0.4s ease, max-height 0.4s ease';
        item.style.opacity = '0';
        item.style.transform = 'translateY(20px)';
        item.style.maxHeight = '0px';
      });

      // Then, after animation completes, set display to none
      setTimeout(() => {
        itemsToHide.forEach((item) => {
          item.style.display = 'none';
          item.dataset.expanded = 'false';
        });
      }, 400); // Match this to the transition duration

      showMoreButton.style.display = '';
      showLessButton.style.display = 'none';

      // Scroll back to the top of the subcollections section
      container.scrollIntoView({behavior: 'smooth'});
    }

    // Run setup
    setupInitialState();

    // Add click event listeners
    showMoreButton.addEventListener('click', expandAll);
    showLessButton.addEventListener('click', collapseToFirstRow);

    // Handle window resize events to recalculate columns
    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        // Only reset if we're in the collapsed state
        if (showMoreButton.style.display !== 'none') {
          setupInitialState();
        }
      }, 250); // Debounce resize events
    });
  }

  // Initialize on document ready
  document.addEventListener('DOMContentLoaded', initSubcollectionsExpandCollapse);

  // VENDOR SELECTION
  const vendorPopupTrigger = document.querySelector('[data-choose-vendor]');
  const vendorPopup = document.querySelector('[data-vendor-popup]');
  const vendorPopupClose = document.querySelector('[data-vendor-popup-close]');
  const selectFavoriteVendorForm = document.querySelector('[data-choose-vendor-form]');

  if (vendorPopupTrigger && vendorPopup && vendorPopupClose) {
    vendorPopupTrigger.addEventListener('click', (e) => {
      e.preventDefault();

      uiHelpers.showLoading();

      apiUtils.getPromoCard(customerSettings.customerEmail).then((data) => {
        uiHelpers.hideLoading();
        uiHelpers.showPopupOverlay();

        if (data.result == false) {
          beautyCardPopup.classList.add('is-visible');
          beautyCardSuccess.classList.remove('is-visible');
          beautyCardFail.classList.add('is-visible');

          createBeautyCardForm.addEventListener('submit', (e) => {
            e.preventDefault();

            createBeautyCardForm.querySelector('button[type="submit"]').disabled = true;
            uiHelpers.showLoading();

            const formData = new FormData(createBeautyCardForm);
            const customerPhone = formData.get('phone');
            const customerFirstName = formData.get('first_name');
            const customerLastName = formData.get('last_name');

            // Use our utility function
            apiUtils
              .createPromoCard({
                email: customerSettings.customerEmail,
                phone: customerPhone,
                firstName: customerFirstName,
                lastName: customerLastName,
                location: 'accountPage',
              })
              .then((data) => {
                console.log('Success:', data);
                uiHelpers.hideLoading();
                beautyCardPopup.classList.remove('is-visible');
                vendorPopup.classList.add('is-visible');
              })
              .catch((error) => {
                console.error('Error:', error);
              });
          });
        } else {
          vendorPopup.classList.add('is-visible');

          selectFavoriteVendorForm.addEventListener('submit', (e) => {
            e.preventDefault();

            selectFavoriteVendorForm.querySelector('button[type="submit"]').disabled = true;

            const formData = new FormData(selectFavoriteVendorForm);
            const vendor = formData.get('vendor');
            const expiryDate = formData.get('expiry_date');

            console.log('submitted');

            uiHelpers.showLoading();

            //  apps.gloross.com/ZlatnaRibka/AddAdditionalTagsToCustomer?customerId={id}&expiryDate=""&vendor=""

            fetch(
              `${apiUtils.baseUrl}/AddAdditionalTagsToCustomer?customerId=${customerSettings.customerId}&expiryDate=${expiryDate}&vendor=${vendor}`,
              {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                },
              }
            )
              .then((response) => response.json())
              .then((data) => {
                console.log(vendor, 'vendor');
                console.log('Success:', data);
                uiHelpers.hideLoading();
                uiHelpers.closePopup();
                window.location.reload();
              })
              .catch((error) => {
                console.error('Error:', error);
                uiHelpers.hideLoading();
              });
          });
        }
      });
    });

    vendorPopupClose.addEventListener('click', (e) => {
      e.preventDefault();
      uiHelpers.closePopup();
    });
  }

  const loginForm = document.querySelector('#customer_login');

  loginForm?.addEventListener('submit', (e) => {
    e.preventDefault();
    uiHelpers.showLoading();

    const formData = new FormData(loginForm);
    const customerEmail = formData.get('customer[email]');

    apiUtils
      .getPromoCard(customerEmail)
      .then((data) => {
        uiHelpers.hideLoading();

        if (data.result) {
          document.cookie = 'has_beauty_card=true; path=/; max-age=31536000'; // 1 year
        } else {
          document.cookie = 'has_beauty_card=false; path=/; max-age=31536000';
        }

        // Submit the form after checking
        loginForm.submit();
      })
      .catch((error) => {
        console.error('Error checking beauty card:', error);
        // Submit anyway in case of error
        loginForm.submit();
      });
  });

  setTimeout(() => {
    if (getBeautyCardButton && window.location.href.includes('account')) {
      const ecomsendWidget = document.querySelector('#ecomsend-widget');

      // Check for the beauty card cookie instead of making an API call
      const hasBeautyCard = apiUtils.getCookie('has_beauty_card');

      if (hasBeautyCard === 'false' || !hasBeautyCard) {
        if (ecomsendWidget) {
          ecomsendWidget.remove();
        }
      }
    }
  }, 1200);

  // Loyalty vendor popup

  document.addEventListener('DOMContentLoaded', () => {
    const declinedFavoriteVendor = apiUtils.getCookie('declined_favorite_vendor');

    if (!loyaltyVendorPopup || declinedFavoriteVendor === 'true') {
      return;
    }

    setTimeout(() => {
      uiHelpers.showPopupOverlay();
      loyaltyVendorPopup.classList.add('is-visible');
    }, 5000);

    loyaltyVendorPopupClose.addEventListener('click', (e) => {
      e.preventDefault();
      uiHelpers.hidePopupOverlay();
      loyaltyVendorPopup.classList.remove('is-visible');
      document.cookie = 'declined_favorite_vendor=true; path=/; max-age=604800'; // 1 year
    });
  });

  // Dynamic tab title when user is away
  function initDynamicTabTitle() {
    if (!window.location.href.includes('cart')) {
      return;
    }

    const originalTitle = document.title;
    const messages = ['Завършете покупката си', 'Преминаване към плащане'];
    let currentMessageIndex = 0;
    let isTabVisible = true;
    let intervalId = null;

    // Function to start alternating messages
    function startAlternating() {
      if (intervalId) return; // Already running

      // Show first message immediately
      document.title = messages[currentMessageIndex];
      currentMessageIndex = (currentMessageIndex + 1) % messages.length;

      intervalId = setInterval(() => {
        if (!isTabVisible) {
          document.title = messages[currentMessageIndex];
          currentMessageIndex = (currentMessageIndex + 1) % messages.length;
        }
      }, 3000);
    }

    // Function to stop alternating and restore original title
    function stopAlternating() {
      if (intervalId) {
        clearInterval(intervalId);
        intervalId = null;
      }
      document.title = originalTitle;
    }

    // Listen for visibility changes
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        // Tab is not visible
        isTabVisible = false;
        startAlternating();
      } else {
        // Tab is visible again
        isTabVisible = true;
        stopAlternating();
      }
    });

    // Listen for focus/blur events (additional fallback)
    window.addEventListener('blur', () => {
      isTabVisible = false;
      startAlternating();
    });

    window.addEventListener('focus', () => {
      isTabVisible = true;
      stopAlternating();
    });
  }

  // Initialize the dynamic tab title
  initDynamicTabTitle();

  // Gift card recipient form validation
  function initGiftCardValidation() {
    const recipientCheckbox = document.querySelector('[data-recipient-checkbox]');
    const emailInput = document.querySelector('[data-voucher-email]');
    const checkoutButton =
      document.querySelector('.shopify-payment-button__button') || document.querySelector('[data-add-to-cart]');

    if (!recipientCheckbox || !emailInput || !checkoutButton) return;

    function validateEmail(email) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    }

    function updateButtonState() {
      if (recipientCheckbox.checked) {
        // Checkbox is checked - button depends on email validity
        const isEmailValid = validateEmail(emailInput.value.trim());
        checkoutButton.disabled = !isEmailValid;
      } else {
        // Checkbox not checked - button is enabled
        checkoutButton.disabled = false;
      }
    }

    // Listen for checkbox changes
    recipientCheckbox.addEventListener('change', updateButtonState);

    // Listen for email input changes
    emailInput.addEventListener('input', updateButtonState);

    // Initial state check
    updateButtonState();
  }

  // Initialize when DOM is ready
  document.addEventListener('DOMContentLoaded', initGiftCardValidation);
})();
